import React, { useRef, useEffect } from 'react';

export const ChainSelector = ({
  chains = [],
  comingSoonChains = [],
  selectedChainKey,
  selectedChain,
  isOpen,
  onToggle,
  onClose,
  onSelectChain,
  isConnected,
  isWalletNetworkAligned,
  networkDisplayName,
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen, onClose]);

  const networkState = isConnected ? (isWalletNetworkAligned ? 'correct' : 'wrong') : 'idle';

  return (
    <div className="chain-selector-inline" ref={containerRef}>
      <button
        type="button"
        className={`chain-selector-trigger network-${networkState}`}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-labelledby="chain-selector-label chain-selector-value"
        onClick={onToggle}
        onKeyDown={e => {
          if (e.key === 'Escape') onClose();
        }}
      >
        <span className="chain-selector-label" id="chain-selector-label">
          Chain
        </span>
        <span className={`chain-status-dot ${networkState}`} aria-hidden="true"></span>
        <span className="chain-selector-current" id="chain-selector-value">
          {selectedChain?.name || 'Select chain'}
          {isConnected && <span className="visually-hidden"> {networkDisplayName}</span>}
        </span>
        <svg
          className={`chevron ${isOpen ? 'open' : ''}`}
          aria-hidden="true"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 4.5l3 3 3-3" />
        </svg>
      </button>
      {isOpen && (
        <div className="chain-selector-menu" role="listbox" aria-label="Select mainnet chain">
          {chains.map(chain => {
            const isActive = selectedChainKey === chain.key;
            return (
              <button
                key={chain.key}
                type="button"
                className={`chain-option-button ${isActive ? 'active' : ''}`}
                onClick={() => onSelectChain(chain.key)}
                role="option"
                aria-selected={isActive}
                title={chain.networkLabel}
              >
                <span className="chain-option-name">{chain.name}</span>
                {isActive && <span className="chain-option-tag">Live</span>}
              </button>
            );
          })}
          {comingSoonChains.map(chain => (
            <button
              key={chain.key}
              type="button"
              className="chain-option-button"
              role="option"
              aria-selected={false}
              aria-disabled="true"
              disabled
            >
              <span className="chain-option-name">{chain.name}</span>
              <span className="chain-option-tag">Soon</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
